import Vue from 'vue';
import axios from 'axios';
import '../../filters';
import moment from 'moment';
import DxDateBox from 'devextreme-vue/date-box';
import { DxTextBox, DxCheckBox, DxNumberBox } from 'devextreme-vue';
import DxRadioGroup from 'devextreme-vue/radio-group';
import {
  DxDataGrid,
  DxColumn,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  DxColumnChooser,
  DxExport,
  DxSelection,
  DxPaging,
  DxSorting,
  DxHeaderFilter,
  DxFilterPanel,
  DxFilterRow,
  DxFilterBuilderPopup,
  DxScrolling,
  DxSummary,
  DxStateStoring,
  DxGroupItem,
  DxTotalItem,
  DxEditing,
  DxPager
} from 'devextreme-vue/data-grid';

const uiDateFormat = 'DD/MM/YYYY';

export default {
  name: 'RSessionData',
  components: {
    DxRadioGroup,
    DxTextBox,
    DxCheckBox,
    DxNumberBox,
    DxDateBox,
    DxColumn,
    DxGroupPanel,
    DxGrouping,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxColumnChooser,
    DxExport,
    DxSelection,
    DxHeaderFilter,
    DxFilterPanel,
    DxFilterRow,
    DxFilterBuilderPopup,
    DxScrolling,
    DxSummary,
    DxStateStoring,
    DxGroupItem,
    DxTotalItem,
    DxEditing,
    DxDataGrid,
    DxPager,
    AttachmentsComp: require('../../components/attachments.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      readOnly: true,
      data: { mimeTypes: 'image/*,application/pdf,app/msword' },
      file: '',
      window: {
        width: 0,
        height: 0,
        isMobile: false
      },
      bDisableButton: false,
      attachments: {
        files: [],
        permissions: { add: true, delete: true, download: true },
        sort: true,
        download: this.download,
        mimeTypes: 'image/png,image/jpeg,application/pdf,application/msword,application/excel',
        multiple: false,
        maxFilesNumber: 3,
        cntrlItemsHelp: []
      },
      rData: {
        amount: 0,
        authDateTime: new Date(),
        authUser: '',
        bankRef: '',
        cashierCash: 0,
        cashierCheque: 0,
        cashierCredit: 0,
        cashierId: 'HCS',
        cashierName: 'EDAMS EDAMS SUPPORT',
        cashierTotal: 0,
        computerCash: 0,
        computerCheque: 0,
        computerCredit: 0,
        computerTotal: 0,
        discrepancy: 0,
        discrepancyCashierComputer: 0,
        lastReceipt: '00000000',
        receiptFrom: '00000000',
        receiptTo: '00000000',
        sessionDate: new Date(),
        sessionId: 0,
        sessionType: 0,
        status: 'Suspended',
        type: 'Receipting session',
        voidedReceipts: 0,
        voidedReceiptsAmount: 0
      },
      rtl: false,
      cols: [],
      receipts: [],
      reports: [],
      receiptsCount: 0,
      filter: '',
      options: { pageSize: 10, total: 0, page: 1 },
      activeTab: 0,
      bAutoExpand: true,
      allowColumnReordering: true,
      allowColumnResizing: true,
      columnAutoWidth: true,
      stateSortingEnabled: false,
      keyColumn: 'receiptNo',
      focusedRowKey: '',
      receiptB4Selected: '',
      bIsReceiptSelected: false,
      showReceiptDialog: false,
      summaryColumn: ''
    };
  },
  computed: {
    languageLocale: function () {
      return this.$i18n.locale;
    },
    GetSummaryColumnName: function () {
      return this.summaryColumn; // || Object.keys(this.receipts[0])[0];
    }
  },
  watch: {
    languageLocale: function (value) {}
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.fillCols();
    this.rData = this.dataObj;
    this.getSessionReports();
    if (this.rData.sessionId > 0) this.getReceipts();
  },
  methods: {
    uploadAttachment(file) {
      var formData = new FormData();
      formData.append('file', file);

      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios
        .post('/ReceiptingSession/UploadFile', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then((response) => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('messages.AttachmentSavedSuccess'), 2);
          } else this.$alertMsg(response.data.data.text);
          loader.hide();
        })
        .catch((e) => {
          loader.hide();
          this.$router.push('/login');
        });
    },
    setActiveTab(tabIndex) {
      this.activeTab = tabIndex;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (window.innerWidth <= 890) {
        this.window.isMobile = true;
      } else {
        this.window.isMobile = false;
      }
    },
    pageChange(pInfo) {
      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
    },
    fillCols() {
      this.cols.push({ dataField: 'receiptNo', width: 80, visible: true, caption: this.$t('receipting.receiptNo') });
      this.cols.push({ dataField: 'billGroup', width: 90, caption: this.$t('enquiriesCustomerDetails.billgroup') });
      this.cols.push({ dataField: 'fullName', width: 200, cellTemplate: 'cellTemplate', caption: this.$t('drilling.Fullname') });
      this.cols.push({ dataField: 'stampTime', visible: true, caption: this.$t('rSessions.authDateTime') });
      this.cols.push({ dataField: 'transactionType', width: 200, caption: this.$t('creditInvoice.TransactionType') });
      this.cols.push({ dataField: 'propertyRef', width: 120, caption: this.$t('enquiriesPropertyDetails.propertyReference') });
      this.cols.push({ dataField: 'closingBalance', alignment: 'right', width: 90, caption: this.$t('rSessions.closingBalance') });
      this.cols.push({ dataField: 'receiptCash', alignment: 'right', width: 90, caption: this.$t('rSessions.receiptCash') });
      this.cols.push({ dataField: 'receiptCheque', alignment: 'right', width: 90, caption: this.$t('rSessions.receiptCheque') });
    },
    getReceipts() {
      var parameter =
        'sessionId=' + this.rData.sessionId + '&filter=' + this.filter + '&pageIndex=' + this.options.page + '&pageSize=' + this.options.pageSize;

      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios
        .post('/ReceiptingSession/GetReceipts?' + parameter)
        .then((response) => {
          if (response.status == 200) {
            var index = 0;
            response.data.items.forEach((item) => {
              item.stampTime = item.stampTime ? moment(item.stampTime).format('DD/MM/YYYY HH:MM') : null;
              item.closingBalance = this.formatMoney(item.closingBalance, 2, '.', ',');
              item.receiptCash = this.formatMoney(item.receiptCash, 2, '.', ',');
              item.receiptCheque = this.formatMoney(item.receiptCheque, 2, '.', ',');
              item.index = index++;
            });
            this.receipts = response.data.items;
            this.options.total = response.data.totalCount;
            this.receiptsCount = response.data.totalCount;
          }
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          this.$alertMsg(error.response.data);
        });
    },
    getSessionReports() {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios
        .get('/ReceiptingSession/GetSessionReports')
        .then((response) => {
          if (response.status == 200) {
            this.reports = response.data.items;
          }
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          this.$alertMsg(error.response.data);
        });
    },
    onFocusedRowChanging: function (e) {
      var pageSize = e.component.pageSize(),
        pageIndex = e.component.pageIndex(),
        isLoading = e.component.getController('data').isLoading(),
        key = e.event && e.event.key;

      if (!isLoading) {
        if (key && e.prevRowIndex === e.newRowIndex) {
          if (e.newRowIndex === pageSize - 1) {
            e.component.pageIndex(pageIndex + 1).done(function () {
              e.component.option('focusedRowIndex', 0);
            });
          } else if (e.newRowIndex === 0) {
            e.component.pageIndex(pageIndex - 1).done(function () {
              e.component.option('focusedRowIndex', pageSize - 1);
            });
          }
        }
      }

      this.chooseReceipt(e);
    },
    onFocusedRowChanged: function (e) {
      //var info = e.row && e.row.data;
      //console.log(info);
      this.focusedRowKey = e.component.option('focusedRowKey');
    },
    onGridCellClick(info) {
      //console.log(info);
    },
    onGridRowDbClick(info) {
      //console.log(info);
    },
    chooseReceipt(info) {
      if (info.newRowIndex < 0) return;

      var currentReceipt = info.rows[info.newRowIndex].data;
      if (currentReceipt === null || currentReceipt === undefined) return;

      this.receiptB4Selected = currentReceipt;
      this.showReceiptDialog = true;
    },
    formatMoney(number, decPlaces, decSep, thouSep) {
      (decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces), (decSep = typeof decSep === 'undefined' ? '.' : decSep);
      thouSep = typeof thouSep === 'undefined' ? ',' : thouSep;
      var sign = number < 0 ? '-' : '';
      var i = String(parseInt((number = Math.abs(Number(number) || 0).toFixed(decPlaces))));
      var j = (j = i.length) > 3 ? j % 3 : 0;

      return (
        sign +
        (j ? i.substr(0, j) + thouSep : '') +
        i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, '$1' + thouSep) +
        (decPlaces
          ? decSep +
            Math.abs(number - parseInt(i))
              .toFixed(decPlaces)
              .slice(2)
          : '')
      );
    },
    onSelected(e) {
      if (e && e.length > 0) this.uploadAttachment(e[0]);
    },
    addDays(date, days) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
    },
    addMonthsUTC(date, count) {
      if (date && count) {
        var m,
          d = (date = new Date(+date)).getUTCDate();

        date.setUTCMonth(date.getUTCMonth() + count, 1);
        m = date.getUTCMonth();
        date.setUTCDate(d);
        if (date.getUTCMonth() !== m) date.setUTCDate(0);
      }
      return date;
    },
    addMonths(date, count) {
      if (date && count) {
        var m,
          d = (date = new Date(+date)).getDate();

        date.setMonth(date.getMonth() + count, 1);
        m = date.getMonth();
        date.setDate(d);
        if (date.getMonth() !== m) date.setDate(0);
      }
      return date;
    },
    formatDateUI(date) {
      return moment(date).add(1, 'days').format(uiDateFormat);
    },
    roundNumberV2(value, decimals) {
      return Number(Math.round(Number(value + 'e' + decimals)) + 'e-' + decimals);
    },
    roundNumberV1(num, scale) {
      var arr = ('' + num).split('e');
      var sig = '';
      if (+arr[1] + scale > 0) {
        sig = '+';
      }
      var i = +arr[0] + 'e' + sig + (+arr[1] + scale);
      var j = Math.round(Number(i));
      var k = +(j + 'e-' + scale);
      return k;
    }
  }
};
